import { useEffect } from 'react';
import { jsx } from 'react/jsx-runtime';

const AccountPickerContainer = ({
  children,
  isVisible
}) => {
  return /*#__PURE__*/jsx("div", {
    style: {
      /**
       * We need to use inline styles here for backwards compatibility
       * with our legacy codebase. We can't use styled-components here.
       */
      backgroundColor: 'rgba(28, 28, 30, 0.6)',
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      zIndex: '2000',
      transition: 'opacity 0.3s',
      visibility: isVisible ? 'visible' : 'hidden',
      opacity: isVisible ? '1' : '0'
    },
    children: children
  });
};
const AccountPicker = ({
  onLoaded,
  onSubmit,
  onCancel,
  onError,
  isVisible: _isVisible = false
}) => {
  const onReceiveMessage = message => {
    if (message.origin === window.location.origin && !!message.data) {
      try {
        const data = JSON.parse(message.data);
        switch (data.type) {
          case 'account-picker/loaded':
            if (onLoaded) {
              var _data$payload, _data$payload2;
              onLoaded(data == null || (_data$payload = data.payload) == null ? void 0 : _data$payload.accountsIds, data == null || (_data$payload2 = data.payload) == null ? void 0 : _data$payload2.workspaceKey);
            }
            break;
          case 'account-picker/submit':
            if (onSubmit) {
              var _data$payload3, _data$payload4, _data$payload5;
              onSubmit(data == null || (_data$payload3 = data.payload) == null ? void 0 : _data$payload3.accountId, data == null || (_data$payload4 = data.payload) == null ? void 0 : _data$payload4.accountsListIndex, data == null || (_data$payload5 = data.payload) == null ? void 0 : _data$payload5.workspaceKey);
            }
            break;
          case 'account-picker/cancel':
            if (onCancel) {
              onCancel();
            }
            break;
          case 'account-picker/error':
            if (onError) {
              onError();
            }
            break;
          default:
            //do nothing
            break;
        }
      } catch (e) {
        //do nothing
      }
    }
  };
  useEffect(() => {
    window.addEventListener('message', onReceiveMessage, true);
    return () => {
      window.removeEventListener('message', onReceiveMessage);
    };
  }, []);
  const accountPickerUrl = `${window.location.origin}/app/account-picker/`;
  return /*#__PURE__*/jsx(AccountPickerContainer, {
    isVisible: _isVisible,
    children: /*#__PURE__*/jsx("iframe", {
      title: "Account picker",
      src: `${accountPickerUrl}?filterCanCreateBoard=1`,
      style: {
        width: '100%',
        height: '100%',
        borderWidth: '0'
      }
    })
  });
};

export { AccountPicker as default };
